import Blazy from './blazy.min.js';

(function () {
    var blazy = new Blazy();
})();


export default function setHeaderOffset() {
    var headerWrapper = document.querySelector(".header-wrapper");
    var siteHeaderWrapper = document.querySelector("#site-header");

    if (headerWrapper) {
        var height = headerWrapper.offsetHeight;
        document.body.style.paddingTop = height + "px";
    }

    if (siteHeaderWrapper) {
        var height = siteHeaderWrapper.offsetHeight;
        document.body.style.paddingTop = height + "px";
    }
}